// Central place for reading REACT_APP_* env vars.
//
// IMPORTANT: reference `process.env.REACT_APP_*` DIRECTLY (as below). CRA's
// webpack DefinePlugin does a *textual* replacement of the exact expression
// `process.env.REACT_APP_X`, swapping in the build-time string literal. Reading
// them indirectly — e.g. `const e = process.env; e.REACT_APP_X`, or guarding on
// `typeof process` — is NOT replaced, and because webpack 5 does not polyfill a
// `process` global, that code falls through to the fallback at runtime in the
// browser. That silently made every production build use the localhost
// fallback regardless of the REACT_APP_STAGING_API set at build time.
//
// After the build, each expression below is inlined to a plain string literal
// (e.g. "https://gateway.cedispay.com.gh"), so there is no `process` access at
// runtime and nothing to crash on — the earlier `typeof process` guard is
// unnecessary as well as harmful.
//
// Fallbacks mirror local dev so URL composition still works if a var is unset.
export const STAGING_API     = process.env.REACT_APP_STAGING_API     || 'http://localhost:8000';
export const STAGING_AUTH    = process.env.REACT_APP_STAGING_AUTH    || '/v2/auth/client';
export const STAGING_LOAN    = process.env.REACT_APP_STAGING_LOAN    || '/v2/loans/client';
export const STAGING_PAYMENT = process.env.REACT_APP_STAGING_PAYMENT || '/v2/payments/client';
export const SITE_NAME       = process.env.REACT_APP_SITE_NAME       || 'CedisPay Micro-Finance Limited';
